import React, { Component } from 'react';
// import $ from 'jquery';
// import 'jquery-ui-bundle/jquery-ui.css';
// import 'jquery-ui-bundle/jquery-ui.js';
// import Tabs from 'react-tabs-navigation';
import T from 'prop-types';
// import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Tabs } from 'antd';
import 'react-tabs/style/react-tabs.css';
import Draggable from 'react-draggable';
import TripsTab from './TripsTab';
// import TripTable from './TripTable';
import RoutesTable from './RoutesTable';
import RoutesTableNew from './RoutesTableNew';
import SchedulesTable from './SchedulesTable';
// import '../ExternalResources/css/jquery-ui.css';
// import '../ExternalResources/js/jquery-1.11.1.js';
// import '../ExternalResources/js/jquery-ui.js';
import { Button as AntdBtn, Icon as AntIcn } from 'antd';

const TabPane = Tabs.TabPane;

class LeftSideNav extends Component {
    constructor() {
        super();
        this.state = {
            trips: [],
            schedulesBrief: [],
            activeTripsSegmentsTabKey: "0",
            // segmentsTabDisabled: true,
            tripsPolylineFinishLoading: true,
            needUpdateComponent: false
        }
        this.tripstab = React.createRef();
    }

    componentWillReceiveProps(theProps) {
        if (this.state.trips !== theProps.trips) {
            this.state.needUpdateComponent = true;
            this.setState({
                trips: theProps.trips,
                needUpdateComponent: true
            });
        }
        if (this.state.activeTripsSegmentsTabKey !== theProps.activeTripsSegmentsTabKey) {
            this.state.needUpdateComponent = true;
            this.setState({
                activeTripsSegmentsTabKey: theProps.activeTripsSegmentsTabKey,
                needUpdateComponent: true
            });
        }
        /* if(this.state.segmentsTabDisabled!==theProps.segmentsTabDisabled){
            this.state.needUpdateComponent = true;
            this.setState({
                segmentsTabDisabled: theProps.segmentsTabDisabled,
                needUpdateComponent: true
            });
        } */
        /* if(this.state.tripsPolylineFinishLoading!==theProps.tripsPolylineFinishLoading){
            this.state.tripsPolylineFinishLoading = true;
            this.setState({
                tripsPolylineFinishLoading: theProps.tripsPolylineFinishLoading,
                needUpdateComponent: true
            });
        } */
        if (this.state.schedulesBrief !== theProps.schedulesBrief) {
            this.state.needUpdateComponent = true;
            this.setState({
                schedulesBrief: theProps.schedulesBrief,
                needUpdateComponent: true
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.needUpdateComponent) {
            this.setState({ needUpdateComponent: false });
            this.state.needUpdateComponent = false;
            return true;
        }
        return false;
    }

    handleLeftBtnTripsSegments = (e) => { this.props.handleLeftBtnTripsSegments(e) }
    updateActiveTab = (theIdx) => { this.props.updateActiveTab(theIdx) }
    updateSchedulesBrief = (theSchedulesBrief) => { this.props.updateSchedulesBrief(theSchedulesBrief) }
    updateTripsClustersRb = (theSelected) => { this.props.updateTripsClustersRb(theSelected) }
    updatePuDoRb = (theSelected) => { this.props.updatePuDoRb(theSelected) }
    updateSelectedTimeSlots = (theTimeSlots) => { this.props.updateSelectedTimeSlots(theTimeSlots) }
    updateSelectAllTimeSlots = (theSelectAllTimeSlots) => { this.props.updateSelectAllTimeSlots(theSelectAllTimeSlots) }
    updateTripsSelection = (theTrips) => { this.props.updateTripsSelection(theTrips) }

    render() {
        // this.initTrips();
        return (
            <Draggable
                // axis="y"
                // bounds="parent"
                handle=".handle"
                defaultPosition={{ x: 0, y: 0 }}
                position={null}
                grid={[25, 25]}
            >
                <div id="myLeftSidenav"  >
                    <div style={{ width: "100%", height: 30, backgroundColor: "rgba(255, 255, 255,0.8)", cursor: "pointer" }} className="handle">
                        <AntdBtn type="primary" /*onClick={(e) => this.props.handleLeftBtnTripsSegments(e)}*/ onClick={this.handleLeftBtnTripsSegments} style={{ float: "center" }}><AntIcn type="left" />Trips / Segments</AntdBtn>
                    </div>
                    {/* < Tabs defaultIndex={0} onSelect={index => this.props.updateActiveTab(index)}>
                        <TabList >
                            <Tab id="left_side_nav_title_tab"><label className="handle">Trips</label></Tab>
                            <Tab id="left_side_nav_title_tab"><label className="handle">Segments</label></Tab>
                        </TabList>

                        <TabPanel>
                            <TripsTab updateTripsClustersRb={this.updateTripsClustersRb} updatePuDoRb={this.updatePuDoRb}
                                updateSelectedTimeSlots={this.updateSelectedTimeSlots} updateSelectAllTimeSlots={this.updateSelectAllTimeSlots} />
                        </TabPanel>
                        <TabPanel>
                            <RoutesTable data={this.props.schedulesBrief} updateSchedulesBrief={this.updateSchedulesBrief} />
                        </TabPanel>
        </Tabs > */}
                    <Tabs className="trips_segments_tab" activeKey={this.state.activeTripsSegmentsTabKey} /*defaultActiveKey="0" onChange={index => this.props.updateActiveTab(index)}*/ onChange={this.updateActiveTab}>
                        <TabPane className="trips_tab" tab="Trips" key="0">
                            <TripsTab ref={this.tripstab} updateTripsClustersRb={this.updateTripsClustersRb} updatePuDoRb={this.updatePuDoRb} trips={this.state.trips}
                                updateTripsSelection={this.updateTripsSelection} updateSelectedTimeSlots={this.updateSelectedTimeSlots}
                                updateSelectAllTimeSlots={this.updateSelectAllTimeSlots} userName={this.props.userName} selectedDate={this.props.selectedDate}
                                GSENodeJsUrl={this.props.GSENodeJsUrl} onReceiveFindBestResult={this.props.onReceiveFindBestResult} handleRefreshTrips={this.props.handleRefreshTrips}/>
                        </TabPane>
                        <TabPane className="segments_tab" /*disabled={this.state.segmentsTabDisabled}*/ tab="Segments" key="1">
                            <RoutesTable data={this.state.schedulesBrief} updateSchedulesBrief={this.updateSchedulesBrief}
                                tripsPolylineFinishLoading={this.state.tripsPolylineFinishLoading} tempShowAllSegments={this.props.tempShowAllSegments} />
                            {/* <RoutesTableNew data={this.props.schedulesBrief} updateSchedulesBrief={this.updateSchedulesBrief} /> */}
                        </TabPane>
                    </Tabs>
                </div>
            </Draggable>
        );
    }
}

export default LeftSideNav;



// WEBPACK FOOTER //
// ./src/Componets/LeftSideNav.js